import { render, staticRenderFns } from "./phseachs.vue?vue&type=template&id=9f1a906c"
import script from "./phseachs.vue?vue&type=script&lang=js"
export * from "./phseachs.vue?vue&type=script&lang=js"
import style0 from "./phseachs.vue?vue&type=style&index=0&id=9f1a906c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports